module.exports = __webpack_public_path__ + "static/media/CAR-2.db5149f7.png";